import React from 'react';
import { motion } from 'framer-motion';

export const WhoAreWe: React.FC = () => {
    return (
        <section className="py-32 bg-white relative overflow-hidden">
            {/* Very subtle background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#11BC97]/5 rounded-full blur-[120px] pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-4xl mx-auto text-center">
                    <motion.span 
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="text-[#11BC97] font-bold tracking-widest uppercase text-sm mb-6 block"
                    >
                        Who We Are
                    </motion.span>
                    
                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className="text-3xl md:text-5xl font-bold mb-10 leading-tight text-black"
                    >
                        Uncompromising quality in a world of uncertainty.
                    </motion.h2>
                    
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="space-y-8 text-gray-600 text-lg md:text-xl font-light leading-relaxed"
                    >
                        <p>
                            At Go Lengthening, we’re committed to improving access to affordable, high-quality orthopaedic care and 
                            to protecting our patients from risky, inexperienced and unscrupulous providers who prioritise profits over 
                            patient outcomes.
                        </p>
                        <p>
                            We don’t compromise on care. Our clinical partners boast a depth of knowledge and experience that 
                            position them among the very best in the world, and are committed to achieving the very best outcomes 
                            for their patients.
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};